module.exports = __webpack_public_path__ + "images/emoji/dolphin.f2ebbd98d9a276bf8353.png";